import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Paper,
  List,
  ListItem,
  Box,
  Typography,
  Chip,
  IconButton,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import axios from "axios";

const ScoresList = () => {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);

  // const courses = [
  //   {
  //     id: 1,
  //     courseName: "Data Structures",
  //     section: "A",
  //     year: 2024,
  //   },
  //   {
  //     id: 2,
  //     courseName: "Database Management",
  //     section: "B",
  //     year: 2024,
  //   },
  //   {
  //     id: 3,
  //     courseName: "Operating Systems",
  //     section: "C",
  //     year: 2024,
  //   },
  // ];

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/course/get-all-course-ids`
        );
        setCourses(response.data?.courses || []);
      } catch (error) {
        console.error("Failed to fetch courses", error);
      }
    };
    fetchCourses();
  }, []);

  const handleCourseClick = (course) => {
    navigate(`${course}/`, {
      state: {
        courseID: course
      },
    });
  };

  return (
    <Paper elevation={3} sx={{ p: 3, m: 2, backgroundColor: "#fff" }}>
      <Typography variant="h4" sx={{ color: "#904dd3", mb: 3 }}>
        Course List
      </Typography>


      <List>
        {courses.map((course) => (
          <ListItem
            key={course}
            sx={{
              flexDirection: "column",
              alignItems: "flex-start",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              mb: 2,
              p: 2,
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#f0f0f0",
              },
            }}
            onClick={() => handleCourseClick(course)}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="h6" sx={{ color: "#333" }}>
                {course.split('-')[0]}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Chip
                  label={`Section ${course.split('-')[2]}`}
                  sx={{ backgroundColor: "#904dd3", color: "white" }}
                />
                <Chip
                  label={course.split('-')[1]}
                  sx={{ backgroundColor: "#2196F3", color: "white" }}
                />
                <IconButton
                  sx={{
                    color: "#904dd3",
                    "&:hover": { backgroundColor: "rgba(144, 77, 211, 0.1)" },
                  }}
                >
                  <ArrowForwardIcon />
                </IconButton>
              </Box>
            </Box>
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default ScoresList;
